import {
// GET ROOM IMAGES
  GET_ROOM_IMAGES,
  GET_ROOM_IMAGES_SUCCESS,
  GET_ROOM_IMAGES_FAILED,

  // ADD IMAGES TO ROOMS
  ADD_IMAGES_TO_ROOMS,
  ADD_IMAGES_TO_ROOMS_SUCCESS,
  ADD_IMAGES_TO_ROOMS_FAILED,

  // DELETE ROOM IMAGES
  DELETE_ROOM_IMAGES,
  DELETE_ROOM_IMAGES_SUCCESS,
  DELETE_ROOM_IMAGES_FAILED,

  // CHANGE POSITION ROOM IMAGES
  CHANGE_POSITION_ROOM_IMAGES,
  CHANGE_POSITION_ROOM_IMAGES_SUCCESS,
  CHANGE_POSITION_ROOM_IMAGES_FAILED,

  // GET ROOMS OF PLACE
  GET_ROOMS_OF_PLACE,
  GET_ROOMS_OF_PLACE_SUCCESS,
  GET_ROOMS_OF_PLACE_FAILED,

  // GET ROOM DETAIL OF PLACE
  GET_ROOM_DETAIL_OF_PLACE,
  GET_ROOM_DETAIL_OF_PLACE_SUCCESS,
  GET_ROOM_DETAIL_OF_PLACE_FAILED,

  //  UPDATE ROOM IMAGES
  UPDATE_ROOM_IMAGES,

  RESET_ROOM_IMAGES,

  // CREATE NEW ROOM
  CREATE_NEW_ROOM,
  CREATE_NEW_ROOM_SUCCESS,
  CREATE_NEW_ROOM_FAILED,

  // UPDATE ROOM OF PLACE
  UPDATE_ROOM_OF_PLACE,
  UPDATE_ROOM_OF_PLACE_SUCCESS,
  UPDATE_ROOM_OF_PLACE_FAILED,

  // DELETE ROOM OF PLACE
  DELETE_ROOM_OF_PLACE,
  DELETE_ROOM_OF_PLACE_SUCCESS,
  DELETE_ROOM_OF_PLACE_FAILED,

  // GET ROOM NAMES SETTING
  GET_ROOM_NAMES,
  GET_ROOM_NAMES_SUCCESS,
  GET_ROOM_NAMES_FAILED,

  // SET ROOM PREVIEW IMAGE
  SET_ROOM_PREVIEW_IMAGE,
  SET_ROOM_PREVIEW_IMAGE_SUCCESS,
  SET_ROOM_PREVIEW_IMAGE_FAILED,

  // UPDATE ROOM VIDEO
  UPDATE_ROOM_VIDEO,
  UPDATE_ROOM_VIDEO_SUCCESS,
  UPDATE_ROOM_VIDEO_FAILED,

  // DELETE ROOM VIDEO
  DELETE_ROOM_VIDEO,
  DELETE_ROOM_VIDEO_SUCCESS,
  DELETE_ROOM_VIDEO_FAILED,
} from './actionTypes';

const initialState = {
  isLoadingAddImagesToRooms: false,
  isLoadingChangePositionRoomImages: false,
  isLoadingCreateNewRoom: false,
  isLoadingDeleteRoomImages: false,
  isLoadingDeleteRoomOfPlace: false,
  isLoadingGetRoomDetailOfPlace: false,
  isLoadingGetRoomImages: false,
  isLoadingGetRoomsOfPlace: false,
  isLoadingSetRoomPreviewImage: false,
  isLoadingUpdateRoomVideo: false,
  isLoadingDeleteRoomVideo: false,
  isLoadingUpdateRoomOfPlace: false,

  roomImageList: [],
  roomsOfPlace: [],
  roomDetailOfPlace: [],
};

export default function room(state = initialState, action) {
  switch (action.type) {
    case GET_ROOM_IMAGES:
      return {
        ...state,
        isLoadingGetRoomImages: true,
      };

    case GET_ROOM_IMAGES_SUCCESS:
      return {
        ...state,
        roomImageList: action.payload.map((item) => ({
          ...item,
          images: item.images?.map((i, index) => ({
            image: i,
            id: index + 1,
          })).sort((a, b) => a.id - b.id),
        })),
        isLoadingGetRoomImages: false,
      };

    case GET_ROOM_IMAGES_FAILED:
      return {
        ...state,
        isLoadingGetRoomImages: false,
      };

    case ADD_IMAGES_TO_ROOMS:
      return {
        ...state,
        isLoadingAddImagesToRooms: true,
      };

    case ADD_IMAGES_TO_ROOMS_SUCCESS:
      return {
        ...state,
        isLoadingAddImagesToRooms: false,
      };

    case ADD_IMAGES_TO_ROOMS_FAILED:
      return {
        ...state,
        isLoadingAddImagesToRooms: false,
      };

    case DELETE_ROOM_IMAGES:
      return {
        ...state,
        isLoadingDeleteRoomImages: true,
      };

    case DELETE_ROOM_IMAGES_SUCCESS:
      return {
        ...state,
        isLoadingDeleteRoomImages: false,
      };

    case DELETE_ROOM_IMAGES_FAILED:
      return {
        ...state,
        isLoadingDeleteRoomImages: false,
      };

    case CHANGE_POSITION_ROOM_IMAGES:
      return {
        ...state,
        isChangePositionRoomImages: true,
      };

    case CHANGE_POSITION_ROOM_IMAGES_SUCCESS:
      return {
        ...state,
        isChangePositionRoomImages: false,
      };

    case CHANGE_POSITION_ROOM_IMAGES_FAILED:
      return {
        ...state,
        isChangePositionRoomImages: false,
      };

    case GET_ROOMS_OF_PLACE:
      return {
        ...state,
        isLoadingGetRoomsOfPlace: true,
      };

    case GET_ROOMS_OF_PLACE_SUCCESS:
      return {
        ...state,
        isLoadingGetRoomsOfPlace: false,
        roomsOfPlace: action.payload,
      };

    case GET_ROOMS_OF_PLACE_FAILED:
      return {
        ...state,
        isLoadingGetRoomsOfPlace: false,
      };

    case GET_ROOM_DETAIL_OF_PLACE:
      return {
        ...state,
        isLoadingGetRoomDetailOfPlace: true,
      };

    case GET_ROOM_DETAIL_OF_PLACE_SUCCESS:
      return {
        ...state,
        isLoadingGetRoomDetailOfPlace: false,
        roomDetailOfPlace: action.payload,
      };

    case GET_ROOM_DETAIL_OF_PLACE_FAILED:
      return {
        ...state,
        isLoadingGetRoomDetailOfPlace: false,
      };

    case UPDATE_ROOM_IMAGES:
      return {
        ...state,
        roomImageList: state.roomImageList.map((item) => {
          if (item._id === action.payload.roomId) {
            return ({
              ...item,
              images: action.payload.images,
            });
          }
          return item;
        }),
      };

    case RESET_ROOM_IMAGES:
      return {
        ...state,
        roomImageList: [],
      };

    case CREATE_NEW_ROOM:
      return {
        ...state,
        isLoadingCreateNewRoom: true,
      };

    case CREATE_NEW_ROOM_SUCCESS:
      return {
        ...state,
        isLoadingCreateNewRoom: false,
      };

    case CREATE_NEW_ROOM_FAILED:
      return {
        ...state,
        isLoadingCreateNewRoom: false,
      };

    case UPDATE_ROOM_OF_PLACE:
      return {
        ...state,
        isLoadingUpdateRoomOfPlace: true,
      };

    case UPDATE_ROOM_OF_PLACE_SUCCESS:
      return {
        ...state,
        isLoadingUpdateRoomOfPlace: false,
      };

    case UPDATE_ROOM_OF_PLACE_FAILED:
      return {
        ...state,
        isLoadingUpdateRoomOfPlace: false,
      };

    case DELETE_ROOM_OF_PLACE:
      return {
        ...state,
        isLoadingDeleteRoomOfPlace: true,
      };

    case DELETE_ROOM_OF_PLACE_SUCCESS:
      return {
        ...state,
        isLoadingDeleteRoomOfPlace: false,
      };

    case DELETE_ROOM_OF_PLACE_FAILED:
      return {
        ...state,
        isLoadingDeleteRoomOfPlace: false,
      };

    case GET_ROOM_NAMES:
      return {
        ...state,
        isLoadingGetRoomNamesSetting: true,
      };

    case GET_ROOM_NAMES_SUCCESS: {
      const roomNamesChildren = [];
      action.payload.roomNames.forEach((category) => {
        category.children.forEach((roomType) => {
          roomNamesChildren.push({
            label: roomType.vi,
            value: roomType.name,
          });
        });
      });
      return {
        ...state,
        isLoadingGetRoomNamesSetting: false,
        roomNames: roomNamesChildren,
      };
    }

    case GET_ROOM_NAMES_FAILED:
      return {
        ...state,
        isLoadingGetRoomNamesSetting: false,
      };

    case SET_ROOM_PREVIEW_IMAGE:
      return {
        ...state,
        isLoadingSetRoomPreviewImage: true,
      };

    case SET_ROOM_PREVIEW_IMAGE_SUCCESS:
      return {
        ...state,
        isLoadingSetRoomPreviewImage: false,
      };

    case SET_ROOM_PREVIEW_IMAGE_FAILED:
      return {
        ...state,
        isLoadingSetRoomPreviewImage: false,
      };

    case UPDATE_ROOM_VIDEO:
      return {
        ...state,
        isLoadingUpdateRoomVideo: true,
      };

    case UPDATE_ROOM_VIDEO_SUCCESS:
      return {
        ...state,
        isLoadingUpdateRoomVideo: false,
      };

    case UPDATE_ROOM_VIDEO_FAILED:
      return {
        ...state,
        isLoadingUpdateRoomVideo: false,
      };

    case DELETE_ROOM_VIDEO:
      return {
        ...state,
        isLoadingDeleteRoomVideo: true,
      };

    case DELETE_ROOM_VIDEO_SUCCESS:
      return {
        ...state,
        isLoadingDeleteRoomVideo: false,
      };

    case DELETE_ROOM_VIDEO_FAILED:
      return {
        ...state,
        isLoadingDeleteRoomVideo: false,
      };

    default:
      return state;
  }
}
